import React, { PureComponent } from 'react'
import { Snackbar, SnackbarContent, Button, IconButton } from '@material-ui/core'
import always from 'ramda/es/always'
import CloseIcon from '@material-ui/icons/Close';

const defaultAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
}

const phonetAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}

export class EnhancedSnackbarBase extends PureComponent {
  render() {
    return (
      <Snackbar
        open={this.props.open}
        onClose={this.getOnClose()}
        anchorOrigin={this.getAnchorOrigin()}
        autoHideDuration={this.getAutoHideDuration()}
      >
        <SnackbarContent
          action={this.getAction()}
          message={this.props.message}
          className={this.props.classes[this.props.type]}
        />
      </Snackbar>
    )
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.props.hideSnackbar()
  }

  getOnClose = () =>
    this.props.type === 'phonet'
      ? this.handleClose
      : this.props.hideSnackbar

  getAnchorOrigin = () =>
    this.props.type === 'phonet'
      ? phonetAnchorOrigin
      : defaultAnchorOrigin

  getAutoHideDuration = () =>
    this.props.type === 'phonet'
      ? null
      : 5000

  getAction = () =>
    this.props.type === 'phonet'
      ? ([
        <Button
          key='add'
          size='small'
          color='secondary'
          onClick={this.onAddClick}
        >
          Добавити
        </Button>,
        <IconButton
          key='close'
          color='inherit'
          onClick={this.handleClose}
        >
          <CloseIcon />
        </IconButton>
      ])
      : null

  onAddClick = () => {
    const [phone, fullName] = this.props.message.split('|')
    const [firstName, lastName] = fullName
      ? fullName.trim().split(' ')
      : ''

    this.props.change('book', 'phone', phone)
    this.props.change('book', 'name', firstName.trim())
    this.props.change('book', 'surname', lastName.trim())
  }
}


// WEBPACK FOOTER //
// ./src/components/EnhancedSnackbar/EnhancedSnackbar.js